import React, { useState, useEffect } from 'react';
import Joyride, { STATUS, ACTIONS, EVENTS } from 'react-joyride';
import { tourSteps, readOnlyTourSteps, tourStyles, tourLocale } from '../../config/tourSteps';
import './TourGuide.css';

/**
 * 画布编辑器新手引导组件
 * @param {boolean} run - 是否运行引导
 * @param {boolean} isReadOnly - 是否为只读模式
 * @param {function} onFinish - 引导完成回调
 */
const TourGuide = ({ run, isReadOnly = false, onFinish }) => {
  const [stepIndex, setStepIndex] = useState(0);

  // 根据模式选择引导步骤
  const steps = isReadOnly ? readOnlyTourSteps : tourSteps;

  useEffect(() => {
    if (run) {
      setStepIndex(0);
    }
  }, [run]);

  const handleJoyrideCallback = (data) => {
    const { status, index, type, action } = data;

    console.log('Joyride callback:', { status, index, type, action, stepIndex });

    // 处理步骤变化
    if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      // 根据用户的动作决定下一个步骤索引
      if (action === ACTIONS.PREV) {
        // 用户点击了"上一步"
        setStepIndex(Math.max(0, index - 1));
      } else if (action === ACTIONS.NEXT) {
        // 用户点击了"下一步"
        setStepIndex(index + 1);
      }
    }

    // 处理引导结束
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if (onFinish) {
        onFinish(status === STATUS.FINISHED);
      }
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showProgress={true}
      showSkipButton={true}
      stepIndex={stepIndex}
      callback={handleJoyrideCallback}
      styles={tourStyles}
      locale={{
        back: '上一步',
        close: '关闭',
        last: '完成',
        next: '下一步',
        nextLabelWithProgress: '下一步（{step} / {steps}）',
        open: '打开',
        skip: '跳过',
      }}
      disableOverlayClose={true}
      disableCloseOnEsc={false}
      spotlightPadding={10}
      scrollToFirstStep={true}
      scrollOffset={100}
    />
  );
};

export default TourGuide;
